import {Directive, HostBinding} from '@angular/core';


// target every <a target="_blank">...<a>
@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'a[target=_blank]',
    standalone: true,
})
export class TargetBlankDirective {
  // will add <a ... rel='noopener noreferrer'>...</a>
  @HostBinding('attr.rel') rel = 'noopener noreferrer';
}
